import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { PROJECT_ORGANISATION_ROLE } from '../../../../../utils/constant';

/**
 * Displays a participant showing the role, name and registration number of the org in a box
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ParticipantView = props => {
  const removeButton = () => {
    if (!props.authorizedActions?.authorizedActions || props.role !== PROJECT_ORGANISATION_ROLE.PROJECT_GENERAL_CONTRACTOR) {
      return;
    }
    const tooltipText = props.authorizedActions.isRemovable ? 'project.remove.generalContractor.participation.button' : 'project.remove.generalContractor.participation.impossible';
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(Translate, {
        value: tooltipText
      }),
      placement: "top",
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "small secondary",
          disabled: !props.authorizedActions.isRemovable,
          onClick: props.onRemoveGC,
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "trash"
          })
        })
      })
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "box border bottom",
    style: {
      width: '100%'
    },
    children: [!props.isInAccordion && /*#__PURE__*/_jsx("div", {
      className: "card-header font-size-xl",
      children: /*#__PURE__*/_jsx(Translate, {
        value: `project.role.${props.role}.title`
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-container space-between",
      children: [/*#__PURE__*/_jsx("b", {
        className: "font-size-xl",
        children: props.organisationName
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-container",
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            whiteSpace: 'nowrap'
          },
          children: props.registrationNumber
        }), removeButton()]
      })]
    })]
  });
};
ParticipantView.defaultProps = {
  isInAccordion: false
};
ParticipantView.propTypes = {
  role: PropTypes.string.isRequired,
  organisationName: PropTypes.string.isRequired,
  registrationNumber: PropTypes.string.isRequired,
  authorizedActions: PropTypes.object,
  onRemoveGC: PropTypes.func,
  isInAccordion: PropTypes.bool
};
export default ParticipantView;